export function isComparisonString(value: string): boolean {
  return (
    isLtComparisonString(value) ||
    isLteComparisonString(value) ||
    isGtComparisonString(value) ||
    isGteComparisonString(value)
  );
}

export function isLtComparisonString(value: string): boolean {
  return value.startsWith('lt-');
}

export function isLteComparisonString(value: string): boolean {
  return value.startsWith('lte-');
}

export function isGtComparisonString(value: string): boolean {
  return value.startsWith('gt-');
}

export function isGteComparisonString(value: string): boolean {
  return value.startsWith('gte-');
}
